import { Box, Container, Stack, SvgIcon, Typography, useTheme } from "@mui/material";
import { ProductContext } from "../provider.js";
import { SuspectName } from "./suspect-name.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import React from "react";
import useEmblaCarousel from "embla-carousel-react";
export const HorizontalLayout = () => {
    const { t } = useTranslation("c-product");
    const theme = useTheme();
    const backgroundColor = theme.palette.grey[100];
    const showArrows = useMediaQuery(theme.breakpoints.up("md"));
    const { suspects = [] } = React.useContext(ProductContext);
    const [emblaRef, embla] = useEmblaCarousel({
        align: "start",
        slidesToScroll: 3,
        skipSnaps: false,
        loop: true,
    });
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [scrollSnaps, setScrollSnaps] = React.useState([]);
    const scrollTo = React.useCallback((index) => embla && embla.scrollTo(index), [embla]);
    const onSelect = React.useCallback(() => {
        if (!embla)
            return;
        setSelectedIndex(embla.selectedScrollSnap());
    }, [embla, setSelectedIndex]);
    const scrollPrev = React.useCallback(() => embla && embla.scrollPrev(), [embla]);
    const scrollNext = React.useCallback(() => embla && embla.scrollNext(), [embla]);
    React.useEffect(() => {
        if (!embla)
            return;
        onSelect();
        setScrollSnaps(embla.scrollSnapList());
        embla.on("select", onSelect);
    }, [embla, onSelect, setScrollSnaps]);
    const ARROW_STYLES = {
        appearance: "none",
        background: "transparent",
        border: 0,
        display: "flex",
        height: "9rem",
        outline: "none",
        position: "absolute",
        svg: { stroke: theme.palette.grey[600] },
        top: "35%",
        transform: "translateY(-50%)",
        transition: theme.transitions.create("stroke"),
        width: "9rem",
        "&:hover": {
            cursor: "pointer",
            svg: { stroke: theme.palette.text.primary },
        },
    };
    return (React.createElement(Box, { component: "section", id: t("anchor-suspects", "der-kreis-der-verdaechtigen"), sx: {
            backgroundColor,
            boxShadow: "sectionBottom",
            position: "relative",
            zIndex: 10,
        } },
        React.createElement(Container, { maxWidth: "xl", sx: { pt: { xs: 8, lg: 14 }, pb: 8 } },
            React.createElement(Typography, { variant: "h2", sx: { pb: 0.5 } }, t("suspects-headline", "Die Verdächtigen")),
            React.createElement(Typography, { variant: "body1" }, t("suspects-copy-1", "Schlüpfe mit deinen Freunde für einen Abend in diese Rollen.")),
            React.createElement(Box, { sx: { position: "relative", mt: 12 } },
                showArrows && (React.createElement(React.Fragment, null,
                    React.createElement(Box, { component: "button", onClick: scrollPrev, sx: { ...ARROW_STYLES, left: "-7rem" } },
                        React.createElement(SvgIcon, { inheritViewBox: true, sx: { width: "100%", height: "auto" } },
                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32.008 140.788" },
                                React.createElement("path", { d: "M-20506.426,2531.312l-30,70,30,70", fill: "none", strokeWidth: "2", transform: "translate(20537.514 -2530.918)" })))),
                    React.createElement(Box, { component: "button", onClick: scrollNext, sx: { ...ARROW_STYLES, right: "-7rem" } },
                        React.createElement(SvgIcon, { inheritViewBox: true, sx: { width: "100%", height: "auto" } },
                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32.008 140.788" },
                                React.createElement("path", { d: "M-20536.426,2531.312l30,70-30,70", fill: "none", strokeWidth: "2", transform: "translate(20537.346 -2530.918)" })))))),
                React.createElement(Box, { className: "embla", id: "product-images-root", ref: emblaRef, sx: {
                        margin: "0 auto",
                        my: -12,
                        overflow: "hidden",
                        pb: 12,
                        position: "relative",
                        pt: 12,
                    } },
                    React.createElement("ul", { className: "embla__container", id: "product-images-container", style: { display: "flex", listStyle: "none", padding: 0 } }, suspects.map(({ age, name, imageWithoutBorder: image, description }) => (React.createElement(Box, { className: "embla__slide transition-all", component: "li", key: `suspect-horizontal-${name}`, sx: { minWidth: "33.33%", px: 4, textAlign: "center" } },
                        React.createElement(Box, { sx: {
                                height: "auto",
                                py: 10,
                                my: -16,
                                transform: "scale(1.5)",
                                transformStyle: "flat",
                                width: "100%",
                            } },
                            React.createElement(Image, { ...image, alt: `${name} (${age})`, placeholder: "empty", style: { width: "100%", height: "auto" } })),
                        React.createElement(SuspectName, { age: age, name: name, sx: { mt: 5 } }),
                        React.createElement(Typography, { variant: "body1" }, description))))))),
            React.createElement(Stack, { direction: "row", id: "suspects-pagination", justifyContent: "center", spacing: 1.5, sx: { mt: { xs: 6, lg: 12 }, width: "100%" } }, scrollSnaps.map((_, index) => (React.createElement(Box, { component: "button", key: `suspect-pagination-${index}`, onClick: () => scrollTo(index), sx: {
                    appearance: "none",
                    background: index === selectedIndex ? theme.palette.text.primary : theme.palette.grey[400],
                    border: 0,
                    borderRadius: "50%",
                    // display: "flex",
                    height: "0.85rem",
                    outline: 0,
                    transition: theme.transitions.create("background", { duration: "fast" }),
                    width: "0.85rem",
                    "&:hover": { cursor: "pointer" },
                } })))))));
};
//# sourceMappingURL=horizontal-layout.js.map